import { ENDPOINTS } from "config/endpoints";
import { useMutation, useQueryClient } from "react-query";
import Error from "types/error";
import client from "utils/client";
import { Request } from "types/request";
import { Response } from "types/response";
import { generatePath } from "react-router-dom";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

export default function useEditUserApiKey() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const editUserApiKey = (id: string) => {
    const request: Request = {
      url: generatePath(ENDPOINTS.users.apiKey, { id }),
      config: {
        method: "patch",
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<Response<null>, Error, string>(
    editUserApiKey,
    {
      onSettled: (data, error, id) => {
        queryClient.invalidateQueries([ENDPOINTS.users.all]);
        queryClient.invalidateQueries([ENDPOINTS.users.one, id]);
      },
      onSuccess: () => {
        toast(t("Api key generated correctly!"));
      },
    }
  );

  return { data, mutate, ...rest };
}
